import React from 'react';
import { Button } from 'antd';
import { SidePanel, LegendWrapper } from './styled';
import type { TreeRootNode } from './hooks/useTreeData';

interface Props {
  data: TreeRootNode[];
  legends: string[];
  onChange: (legends: string[]) => void;
}

const Legend = ({ color, children }: { color?: string; children: React.ReactNode }) => {
  return (
    <LegendWrapper $color={color}>
      <span>{children}</span>
    </LegendWrapper>
  )
}

const PartitionList = ({ data = [], onChange, legends }: Props) => {
  const groups = data.map(i => ({ key: i.name, value: i.value, color: i.color }));

  const onClickTag = (legend: string, checked: boolean) => () => {
    const nextLegends = checked ? [...legends, legend] : legends.filter(l => l !== legend);
    onChange(nextLegends);
  }

  return (
    <SidePanel>
      {groups.map((label) => {
        const checked = legends.includes(label.key);
        return (
          <Button type="link" key={label.key} onClick={onClickTag(label.key, !checked)}>
            <Legend color={checked ? label.color : undefined}>{label.key}</Legend>
          </Button>
        )
      })}
    </SidePanel>
  )
}

export default PartitionList;
